export function getTranslation(lang: string): {
    login: string;
    loginButton: string;
    whatCanWeHelpYouWith: string;
    startTypingHere: string;
    openButton: string;
    continue: string;
    cancel: string;
    goBack: string;
} {
    const translationStrings = {
        en: {
            login: 'Log in',
            loginButton: 'Log in',
            whatCanWeHelpYouWith: 'What can we help you with?',
            startTypingHere: 'Start typing here…',
            openButton: 'Open',
            continue: 'Continue',
            cancel: 'Cancel',
            goBack: 'Go Back'
        },
        es: {
            login: 'Iniciar sesión',
            loginButton: 'Entrar',
            whatCanWeHelpYouWith: '¿En qué podemos ayudarle?',
            startTypingHere: 'Empiece a escribir aquí…',
            openButton: 'Abrir',
            continue: 'Continuar',
            cancel: 'Cancelar',
            goBack: 'Atras'
        }
    }
    return translationStrings[lang];
}
